import { resolveEmojiUnifiedId, unifiedToEmoji } from "@/components/emoji/emoji-datasource.ts";

interface MarkdownNode {
  type: string;
  value?: string;
  children?: MarkdownNode[];
}

const SHORTCODE = /:([a-z0-9_+-]+):/gi;

const replaceShortcodes = (text: string) =>
  text.replace(SHORTCODE, (match, code: string) => {
    const unified = resolveEmojiUnifiedId(`:${code}:`);
    return unified ? unifiedToEmoji(unified) : match;
  });

// Только узлы text: code и inlineCode в mdast — свои типы, коды в них остаются как есть
const replaceInTextNodes = (node: MarkdownNode) => {
  if (node.type === "text" && node.value) node.value = replaceShortcodes(node.value);
  node.children?.forEach(replaceInTextNodes);
};

export const remarkEmojiShortcodes = () => replaceInTextNodes;
